import { useCallback, useEffect, useState } from 'react';
import { getMenuFunctions } from '../services/userManagementservice';

export const useMenuFunction = (type) => {
    const [functions, setFunctions] = useState([])

    useEffect(() => {
        if (type) {
            getFunctions(type);
        }
    }, [type])

    const getFunctions = (type) => {
        let userData = JSON.parse(localStorage.getItem('user'));
        let menusAccess = userData?.MenuList;

        let ans = menusAccess?.find(m => m.Menuname === type)
        let userRoleId = ans?.UserRoleID
        let menuId = ans?.MenuID
        if (userRoleId && menuId) {
            getMenuFunctions(userRoleId, menuId)
                .then((response) => {
                    if (response.Status === "success") {
                        setFunctions(response.Data);
                    } else {
                        setFunctions([]);
                    }
                })
                .catch((error) => {
                    setFunctions([]);
                    console.error('Error fetching functions:', error);
                });
        }
    }

    const showFunction = useCallback((key) => {
        let fun = functions.find((item) => item.FunctionKey === key);
        // return false
        return fun?.IsAllowed ?? false;
    }, [functions]);

    return { functions, getFunctions, showFunction }
}